module.exports = __webpack_public_path__ + "static/media/credex-logo-1.ed87524d.svg";